<template>
  
    <div class="me-2">

        <div  class="flex justify-end items-center w-full mb-3 lg:mb-16 text-base"
        :class="{'justiify-between': isBetween}">   
        
            <label v-if="!hideName" class="mr-2 lg:mr-5"><strong>{{$t(`${nameLabel}`)}}  </strong></label>

            <div class="border-2 border-black"
            :class=" {'ms-24': isBetween}">
                <vue-multi-select
                v-model="listOptionspProxy"
                :search="!isNoSearch"
                :btnLabel="BtnLabel"
                :position="position"
                :options="options"
                @input="callItemIsSelected"
                :selectOptions="listOptions"/>
            </div> 
        </div>
    </div>
</template>

<script>

import vueMultiSelect from 'vue-multi-select'; 
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import componentHelpers from '../../classes/componentHelpers';

export default {

    mounted(){

        // console.log(`initialId: ${this.myInitialId}`);

        // console.log(`storageName: ${this.storageName}`);
        let id = 0;

        if(this.storageName != ''){

            id = this.getIdFromStorage(this.storageName);
        }

        if(id != 0){

            this.setSelection(id);
        }

        // console.log(`this.initialId: ${this.initialId}`);

        if(this.initialId != 0){
            
            const id = this.initialId;

            this.setSelection(id);

            // componentHelpers.printJson('listOptionspProxy', this.listOptionspProxy);
        }else if(this.listOptions.length == 1){

            // console.log(`listOptions.length = 1`)
            this.listOptionspProxy.push(this.listOptions[0]);
            // componentHelpers.printJson('listOptionspProxy', this.listOptionspProxy);
        }
    },

    props:{

        hideName: false,

        isNoSearch: false,

        storageName: '',

        myInitialId: 0,

        isBetween: false,

        name: '',

        listLabel: '',

        listOptions:{

            type: Array
        },

        itemIsSelected: {

            type: Function
        },

        noItemIsSelected: {

            type: Function
        },
        multiSelection: false,
    },

    components:{

        vueMultiSelect
    },

    methods:{

        setSelection(id){

            if(!this.multiSelection && id != 0){

                const temp = this.listOptions.filter(item=> item.id == id);

                if(temp.length > 0){

                    this.listOptionspProxy = new Array();

                    this.listOptionspProxy.push(temp[0]);
                }
            }else{

                console.log(`in else`)
            }
        },

        callItemIsSelected(selected){

            if(selected.length > 0){

                if(!this.multiSelection){

                    this.saveIdToStorage();    
                }

                this.itemIsSelected(selected[0]);
            }else{

                this.callNoItemIsSelected();
            }
        },


        callNoItemIsSelected(){

            this.noItemIsSelected();
        },

        saveIdToStorage(){

            localStorage.setItem(this.storageName, this.listOptionspProxy[0].id);
        },

        getIdFromStorage(){

            if(localStorage.hasOwnProperty(this.storageName)){

                const id = Number(localStorage.getItem(this.storageName));

                // console.log(`id: ${id}`);
                return id;
            }else{

                return 0;
            }
        },

    },

    data: function(){

        return{

            initialId: this.myInitialId ? this.myInitialId: 0,

            nameLabel: this.name,

            listOptionspProxy: [],

            BtnLabel: values => this.listOptionspProxy.length > 0 ? this.listOptionspProxy[0].name : this.listLabel,

            position: this.$i18n.locale == 'ar'? 'bottom-left' :  'bottom-right',

            options: {

                multi: this.multiSelection,
                cssSelected: option => (option.selected ? { 'background-color': '#5764c6' } : ''),
            },
        }
    }
}
</script>

<style>

</style>